<template>
  <div class="tree-box  main-box">
    <div class="area-tree">
      <div class="tree-box">
        <div class="tree-header" @click="clickTop">
          组织机构
        </div>
        <div class="zTreeDemoBackground left tree-scroll">
          <ul :id="treeIdValue" class="ztree"></ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '../../../../static/js/jquery-3.7.1'
import "../../../../plugins/zTree/js/jquery.ztree.core.min.js";
import "../../../../plugins/zTree/js/jquery.ztree.excheck.min.js";

export default {
  name: 'menuTree',
  props: {
    treeId: {
      type: String,
      default: 'orgTreeDemo'
    },
    orgCategory: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      project_id: '',
      org_list: [],
      selected_id: '-1',
      treeIdValue: this.treeId || 'orgTreeDemo',
      // 存储机构ID到orgCategory的映射
      orgCategoryMap: {},
      setting:{
        data:{
          simpleData:{
            enable: true,
            idKey: "id",
            pIdKey: "p_id",
            rootPId: 0
          }
        },
        view: {
          showIcon: true,
          // 自定义图标处理函数，确保PNG图标正确显示
          addDiyDom: (treeId, treeNode) => {
            // 使用 setTimeout 确保 DOM 已经渲染完成
            setTimeout(() => {
              let nodeAnchor = $("#" + treeNode.tId + "_a");
              if (nodeAnchor.length === 0) {
                return;
              }
              // 找到图标元素 - zTree 的图标通常在 span.button 中
              let iconElement = nodeAnchor.find("span.button.ico_open, span.button.ico_close, span.button.ico_docu").first();
              // 如果没找到，尝试找所有 button 元素
              if (!iconElement.length) {
                iconElement = nodeAnchor.find("span.button").first();
              }
              // 如果还是没找到，尝试找包含图标的第一个 span
              if (!iconElement.length) {
                iconElement = nodeAnchor.children("span").first();
              }
              if (iconElement.length > 0) {
                // 移除所有图标相关的类
                iconElement.removeClass('ico_open ico_close ico_docu button');
                // 清空背景图片和内联样式
                iconElement.css({
                  'background': 'none !important',
                  'background-image': 'none !important',
                  'background-position': 'initial !important'
                });

                // 移除所有类
                iconElement.removeClass();
                iconElement.addClass('org-tree-icon');

                // 设置背景图片路径（如果有iconUrl）
                if (treeNode.iconUrl) {
                  iconElement.css('background-image', 'url(' + treeNode.iconUrl + ')');
                }
              }
            }, 10);
          }
        },
        edit: {
          drag: {
            isCopy: true,
            isMove: true
          },
          enable: true,
          showRemoveBtn: false,
          showRenameBtn: false
        },
        callback: {
          onClick: this.zTreeOnClick,
          onDrop: this.zTreeOnDrop,
          onNodeCreated: this.handleNodeCreated,
          onExpand: this.handleNodeExpand
        }
      },
      zNodes: [],
      treeObj: new Object(),

    }
  },
  created(){
    if(!this.treeIdValue || this.treeIdValue === '' || this.treeIdValue === undefined){
      this.treeIdValue = 'orgTreeDemo';
    }
    this.init();
  },
  methods: {
    init() {
      this.$nextTick(()=>{
        this.initDeptTree();
      })
    },
    editSelect:function(){
      this.initDeptTree();
    },
    refresh:function(){
      this.initDeptTree();
    },
    // 获取所有机构的orgCategory映射
    getOrgCategoryMap: function() {
      return this.request({
        method:'post',
        url:'/web/service',
        params:{
          'method':'tCoreOrg_list',
          'pId': -10,
          'page': 1,
          'rows': 10000
        }
      }).then((response) => {
        if (response.code === 0 && response.rows) {
          let map = {};
          response.rows.forEach(item => {
            if (item.id && item.orgCategory) {
              map[item.id] = item.orgCategory;
            }
          });
          console.log('orgCategory映射表:', map);
          console.log('映射表大小:', Object.keys(map).length);
          return map;
        }
        console.warn('获取orgCategory映射失败或数据为空');
        return {};
      });
    },
    // 根据节点名称判断机构类型（优先级最高）
    getCategoryByName: function(name) {
      if (!name) return null;

      // 供应商相关
      if (name.indexOf('供应商') >= 0 || name.indexOf('供应商企业') >= 0) {
        return '3';
      }
      // 采购商相关
      if (name.indexOf('采购商') >= 0) {
        return '2';
      }
      // 平台相关
      if (name.indexOf('平台') >= 0 || name.indexOf('数勤通') >= 0) {
        return '1';
      }

      return null;
    },
    // 递归设置图标：如果节点没有orgCategory，从父节点继承
    setIconRecursively: function(nodes, parentCategory, isChildNode = false) {
      for(let i = 0; i < nodes.length; i++) {
        let node = nodes[i];

        // 优先级：1. 根据名称判断（最高优先级） 2. 映射表中的值 3. 节点自身的orgCategory 4. 父节点的值 5. 组件传入的值
        let category = this.getCategoryByName(node.name)
          || this.orgCategoryMap[node.id]
          || node.orgCategory
          || parentCategory
          || this.orgCategory;

        // 根据orgCategory设置不同PNG图标
        // 特殊处理：如果节点名称包含"用户管理"，使用默认图标
        if (node.name && node.name.indexOf('用户管理') >= 0) {
          // 保持用户管理节点的默认样式，不设置图标
        }
        // 平台机构/供应链使用供应链图标
        else if(category == '1' || category == 1){
          node.iconUrl = require('../../../assets/img/common/供应链.png');
        }
        // 采购商使用采购商图标
        else if(category == '2' || category == 2){
          // 如果是子节点，使用采购商子树图标
          if (isChildNode) {
            node.iconUrl = require('../../../assets/img/common/采购商子树.png');
          } else {
            node.iconUrl = require('../../../assets/img/common/采购商.png');
          }
        }
        // 供应商使用供应商图标
        else if(category == '3' || category == 3){
          // 如果是子节点，使用供应商子树图标
          if (isChildNode) {
            node.iconUrl = require('../../../assets/img/common/供应商子树.png');
          } else {
            node.iconUrl = require('../../../assets/img/common/供应商.png');
          }
        } else {
          // 如果没有category，不设置图标
        }

        console.log('节点:', node.name, 'category:', category, 'iconSkin:', node.iconSkin, '映射表值:', this.orgCategoryMap[node.id]);

        // 递归处理子节点，传递当前节点的category，并标记为子节点
        if(node.children && node.children.length > 0) {
          this.setIconRecursively(node.children, category, true);
        }
      }
    },
    //初始化部门树
    initDeptTree: function(){
      // 先获取orgCategory映射，然后获取树形数据
      return Promise.all([
        this.getOrgCategoryMap(),
        this.request({
          method:'post',
          url:'/web/service',
          params:{
            'method':'tCoreOrg_getZtreeData',
            'orgCategory': this.orgCategory
          }
        })
      ]).then(([orgCategoryMap, response]) => {
        // 保存映射表
        this.orgCategoryMap = orgCategoryMap;

        if (response.code === 0) {
          let list = response.rows;
          if(list == null || list == '' || list == undefined || list.length < 0){
            return false;
          }

          console.log('原始数据:', list);

          // 构建树结构
          let treeMap = {};
          let rootNodes = [];

          // 创建节点映射
          for(let i = 0; i < list.length; i++) {
            list[i].children = [];
            treeMap[list[i].id] = list[i];
          }

          // 构建树结构
          for(let i = 0; i < list.length; i++) {
            let node = list[i];
            if(node.p_id == 0 || !treeMap[node.p_id]) {
              rootNodes.push(node);
            } else {
              let parent = treeMap[node.p_id];
              if(!parent.children) parent.children = [];
              parent.children.push(node);
            }
          }

          // 递归设置图标
          this.setIconRecursively(rootNodes, this.orgCategory);

          // 扁平化回数组（zTree需要扁平数组）
          const flattenTree = (nodes) => {
            let result = [];
            for(let node of nodes) {
              let nodeCopy = {...node};
              delete nodeCopy.children;
              result.push(nodeCopy);
              if(node.children && node.children.length > 0) {
                result = result.concat(flattenTree(node.children));
              }
            }
            return result;
          };

          this.zNodes = flattenTree(rootNodes);
          console.log('设置图标后的数据:', this.zNodes);

          this.treeObj = $.fn.zTree.init($("#" + this.treeIdValue), this.setting, this.zNodes);

          let nodes = this.treeObj.getNodes();
          //默认展开所有节点
          this.treeObj.expandAll(true);

          //选中第一个节点
          if(nodes && nodes.length > 0) {
            this.treeObj.selectNode(nodes[0], true);
            this.$emit('listenToChildEvent',nodes[0].id)
          }
        }
      }).catch((error) => {
        console.error('获取机构树数据失败:', error);
      });
    },
    //树的点击事件
    zTreeOnClick:function(event, treeId, treeNode){
      if(treeNode.id != null && treeNode.id != '' && treeNode.id != undefined){
        this.selected_id = treeNode.id;
        this.$emit('listenToChildEvent',treeNode.id)
      }
    },
    //拖拽结束事件
    zTreeOnDrop:function(event, treeId, treeNodes, targetNode, moveType){
      alert(treeNodes.length + "," + (targetNode ? (targetNode.tId + ", " + targetNode.name) : "isRoot" ));
    },

    // 处理节点创建时的图标渲染
    handleNodeCreated:function(event, treeId, treeNode){
      this.applyIconStyles(treeNode);
    },

    // 处理节点展开时的图标重新渲染
    handleNodeExpand:function(event, treeId, treeNode){
      // 递归处理当前节点及其所有子节点
      this.applyIconStylesToChildren(treeNode);
    },

    // 应用图标样式的核心函数
    applyIconStyles:function(treeNode){
      // 使用 setTimeout 确保 DOM 已经渲染完成
      setTimeout(() => {
        let nodeAnchor = $("#" + treeNode.tId + "_a");
        if (nodeAnchor.length === 0) {
          return;
        }
        // 找到图标元素 - zTree 的图标通常在 span.button 中
        let iconElement = nodeAnchor.find("span.button.ico_open, span.button.ico_close, span.button.ico_docu").first();
        // 如果没找到，尝试找所有 button 元素
        if (!iconElement.length) {
          iconElement = nodeAnchor.find("span.button").first();
        }
        // 如果还是没找到，尝试找包含图标的第一个 span
        if (!iconElement.length) {
          iconElement = nodeAnchor.children("span").first();
        }
        if (iconElement.length > 0) {
          // 移除所有图标相关的类
          iconElement.removeClass('ico_open ico_close ico_docu button');
          // 清空背景图片和内联样式
          iconElement.css({
            'background': 'none !important',
            'background-image': 'none !important',
            'background-position': 'initial !important'
          });

          // 移除所有类
          iconElement.removeClass();
          iconElement.addClass('org-tree-icon');

          // 设置背景图片路径（如果有iconUrl）
          if (treeNode.iconUrl) {
            iconElement.css('background-image', 'url(' + treeNode.iconUrl + ')');
          }
        }
      }, 10);
    },

    // 递归应用图标样式到所有子节点
    applyIconStylesToChildren:function(treeNode){
      // 先处理当前节点
      this.applyIconStyles(treeNode);

      // 递归处理子节点
      if (treeNode.children && treeNode.children.length > 0) {
        for (let i = 0; i < treeNode.children.length; i++) {
          this.applyIconStylesToChildren(treeNode.children[i]);
        }
      }
    },
    freshArea:function(){
      $.fn.zTree.init($("#" + this.treeIdValue), this.setting, this.zNodes);
    },
    //添加根目录
    addRoot: function () {
      this.$emit('handleAddOpenDialog',"-1")
    },
    //点击【组织机构】
    clickTop:function(){
      this.selected_id = '-1';
      this.treeObj.cancelSelectedNode();
      this.$emit('listenToChildEvent', "-1");
    },
    //添加子目录
    addChild: function () {
      if(this.selected_id == null || this.selected_id == undefined || this.selected_id == ''){
        this.$message.error("请选择需要添加的节点！");
        return false;
      }
      this.$emit('handleAddOpenDialog', this.selected_id)
    },
    //删除菜单
    deleteItem:function(){
      let treeObj = $.fn.zTree.getZTreeObj("" + this.treeIdValue);
      let nodes = treeObj.getSelectedNodes();

      if(nodes.length < 1){
        this.$message.error("请选择需要删除的节点！");
        return false;
      }
      if(nodes.length > 1){
        this.$message.error("有且只能选择一个节点进行删除！");
        return false;
      }
      let select_node = nodes[0];

      if(select_node.children && select_node.children.length > 0){
        this.$message.error("该节点有子节点，不能删除！");
        return false;
      }
      this.$confirm(`确定进行删除操作?`, '提示',{confirmButtonText: '确定', cancelButtonText: '取消',type: 'warning'}).then(() => {
        return this.request({
          method:'post',
          url:'/web/service',
          params:{
            'method':'tCoreMenu_delete',
            'id': select_node.id
          }
        }).then((response) =>{
          if(response.code != '0'){
            this.$message.error(response.msg);
            return false;
          }
          this.$message({message: '操作成功', type: 'success', duration: 1500, onClose: () => {
              treeObj.removeNode(select_node);
            }
          })
        })
      }).catch(() => {})
    }
  },
}
</script>

<style>
@import '../../../../plugins/zTree/css/zTreeStyle/zTreeStyle.css';
/* 去除图标边框和轮廓 */
.ztree li span.button.wk {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  background: none !important;
  background-image: none !important;
  padding: 0 !important;
  margin: 0 4px 0 0 !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* 确保图标元素没有边框 */
.ztree li a span.button.wk:before {
  border: none !important;
  outline: none !important;
}

/* PNG图标样式 */
.org-tree-icon {
  width: 16px !important;
  height: 16px !important;
  display: inline-block !important;
  margin-right: 4px !important;
  vertical-align: middle !important;
  background-size: contain !important;
  background-repeat: no-repeat !important;
  background-position: center !important;
  border: none !important;
  outline: none !important;
  padding: 0 !important;
  margin: 0 4px 0 0 !important;
}
.tree-scroll {
  height: 95%;
  /* 溢出时显示滚动条 */
  overflow-y: auto;
  /* 可选：美化滚动条（适配Chrome/Safari） */
  scrollbar-width: thin; /* Firefox */
}
</style>



// WEBPACK FOOTER //
// src/views/sys/org/org-view-tree.vue